import axios from "axios";
/* NPROGRESS START */
import NProgress from "nprogress";
const progressShowDelay = 10;
let routeResolved = false;

const baseOsapmUrl = process.env.VUE_APP_API_EXTERNAL;
const baseZaiqUrl = process.env.VUE_APP_API;

/**
 * Initializes NProgress after a specified delay only if the route was not resolved yet.
 */
function tryInitProgress() {
  routeResolved = false;
  setTimeout(() => {
    if (!routeResolved) {
      NProgress.start();
    }
  }, progressShowDelay);
}

/**
 * Interceptors
 */
export function setInterceptors(axiosInstance) {
  axiosInstance.interceptors.request.use(
    config => {
      //console.log("REQUEST STARTED");
      tryInitProgress();
      return config;
    },
    error => {
      //console.log("REQUEST ERROR FINISH LOADING");
      routeResolved = true;
      NProgress.done();
      return Promise.reject(error);
    }
  );

  axiosInstance.interceptors.response.use(
    response => {
      //console.log("RESPONSE FINISHED");
      routeResolved = true;
      NProgress.done();
      return response;
    },
    error => {
      //console.log("RESPONSE ERROR FINISH LOADING");
      routeResolved = true;
      NProgress.done();
      return Promise.reject(error);
    }
  );
}

/* NPROGRESS END */

export default {
  osapm() {
    var axiosInstance = axios.create({
      baseURL: baseOsapmUrl,
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token")
      }
    });

    setInterceptors(axiosInstance);
    return axiosInstance;
  },
  zaiq() {
    var axiosInstance = axios.create({
      baseURL: baseZaiqUrl
    });

    setInterceptors(axiosInstance);
    return axiosInstance;
  }
};